import React from 'react';
import styled from 'styled-components';
import { PodcastGirl, PodcastMan } from 'src/assets/images';

const PodcastSection: React.FC = () => {
  return (
    <Container>
      <Content>
        <PodcastGirlImage src={PodcastGirl} alt="Podcast Girl" />
        <TextContent>
          <Title><span>The Pivot Point</span> Podcast</Title>
          <Description>
            The most unfiltered podcast for startups and investors.
            Real talk. Sharp insights. Clearly every founder needs.
          </Description>
          <Subtitle>[COMING SOON]</Subtitle>
        </TextContent>
        <PodcastManImage src={PodcastMan} alt="Podcast Man" />
      </Content>
    </Container>
  );
};

const Container = styled.section`
  padding: 30px 60px;
  background-color: #fafafa;
  text-align: center;

  @media (max-width: 768px) {
    padding: 20px 30px;
  }
  @media (max-width: 480px) {
    padding: 15px 20px;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  background: #ffffff;
  border-radius: 12px;
  padding-top: 20px;
  box-shadow: 0 15px 50px rgba(17, 28, 43, 0.01);
  border: 0.5px solid rgba(255, 91, 36, 0.3);
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 20px;
    padding: 30px 20px;
  }
  @media (max-width: 480px) {
    padding: 20px 15px;
    gap: 15px;
  }
    &:hover {
    border-color: #ff5924;
    box-shadow: 0 25px 60px rgba(255, 89, 36, 0.15);
  }
`;

const TextContent = styled.div`
  flex: 1;
  @media (max-width: 480px) {
    margin-top: 40px;
  }
`;

const Title = styled.h2`
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 16px;
  
  span {
    background: linear-gradient(90deg, #FF5733, #FF8C00);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const Subtitle = styled.div`
  font-size: 24px;
  color: #FF9E85;
  margin-bottom: 24px;
  font-weight: bold;
`;

const Description = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  max-width: 500px;
`;

const PodcastGirlImage = styled.img`
  width: 300px;
  @media (max-width: 768px) {
    width: 250px;
  }
  @media (max-width: 480px) {
    display: none;
  }
`;

const PodcastManImage = styled.img`
  width: 300px;
  margin-top: 10px;
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 0;
  }
  @media (max-width: 480px) {
    width: 100%;
    margin-top: 0;
  }
`;
export default PodcastSection;
